import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // 10 min — analysis data is immutable
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
